export default __webpack_public_path__ + "static/media/product-15 (2).55e6ced4.jpg";